import MODULE_KEYWORDS from 'components/Modules/keywords';

export const PAYMENT_PAYCUT_PAYMENTS_FIELD_ID = 'paycutPaymentsAction';
export const PAYMENT_PAYCUTS_DATASOURCE_ID = 21;
export const PAYMENT_TABLE_CONTEXTS = Object.freeze({
	ROOT_STANDARD_TABLE: 'root-standard-table',
	PAYCUT_PAYMENTS: 'paycut-payments',
	PAYMENT_LINES: 'payment-lines',
	PAYMENT_ORDERS: 'payment-orders',
});

export const PAYMENT_PAYCUT_PAYMENTS_FIELD = {
	id: PAYMENT_PAYCUT_PAYMENTS_FIELD_ID,
	name: 'Ver pagos',
	width: 110,
	type: 'action',
	filterable: false,
	unselectable: true,
};

export function isPaymentsPaycutDatasource(
	selectedDataFilterId,
	selectedSubModule,
	tableContext,
) {
	const { BILLINGS } = MODULE_KEYWORDS.MODULES.ITEMS.KEYS;

	return (
		tableContext === PAYMENT_TABLE_CONTEXTS.ROOT_STANDARD_TABLE &&
		selectedSubModule?.key === BILLINGS.PAYMENTS &&
		Number(selectedDataFilterId) === PAYMENT_PAYCUTS_DATASOURCE_ID
	);
}

export function isNestedPaycutPaymentsTable(tableContext, selectedSubModule) {
	const { BILLINGS } = MODULE_KEYWORDS.MODULES.ITEMS.KEYS;

	return (
		tableContext === PAYMENT_TABLE_CONTEXTS.PAYCUT_PAYMENTS &&
		selectedSubModule?.key === BILLINGS.PAYMENTS
	);
}

export function addPaymentPaycutActionFields(
	fields = [],
	selectedSubModule,
	selectedDataFilterId,
	tableContext,
) {
	if (isNestedPaycutPaymentsTable(tableContext, selectedSubModule)) {
		return fields
			.filter(field => field.id !== PAYMENT_PAYCUT_PAYMENTS_FIELD_ID)
			.map(field =>
				field.id === 'id'
					? {
							...field,
							opensPaycutSummary: false,
							opensPaymentSummary: true,
						}
					: field,
			);
	}

	if (
		!isPaymentsPaycutDatasource(
			selectedDataFilterId,
			selectedSubModule,
			tableContext,
		)
	)
		return fields;

	const preparedFields = fields.map(field => {
		if (field.id === 'id') return { ...field, opensPaycutSummary: true };
		if (field.id === 'paycut_name') return { ...field, disableOverview: true };
		return field;
	});

	if (
		preparedFields.some(field => field.id === PAYMENT_PAYCUT_PAYMENTS_FIELD_ID)
	)
		return preparedFields;

	const idPosition = preparedFields.findIndex(field => field.id === 'id');

	return [
		...preparedFields.slice(0, idPosition + 1),
		PAYMENT_PAYCUT_PAYMENTS_FIELD,
		...preparedFields.slice(idPosition + 1),
	];
}
